const config = {
  API_URL: process.env.REACT_APP_API_URL,
  AMPLITUDE_KEY: process.env.REACT_APP_AMPLITUDE_KEY,
  SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV,
};

export default config;
